var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text--primary"},[_c('px-acompanhamentos',{attrs:{"allow-files":"","item-type":_vm.messageType,"item-id":_vm.contratacao.id,"user":_vm.user},on:{"on-message":_vm.onMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }